// extracted by mini-css-extract-plugin
export default {"teamMember":"TeamMember_teamMember__YC6LF","employee":"TeamMember_employee__9fpVl","name":"TeamMember_name__74AAC","textCard":"TeamMember_textCard__j7yO2"};